import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

import { Button, ButtonVariant } from '@/components/form/button';

export const CalibrationCloseStep = ({
  onSwitchBackToMobileCam,
}: {
  onSwitchBackToMobileCam: () => void;
}) => {
  const { t } = useTranslation();
  const { goToStep } = useWizard();

  return (
    <>
      <div className="py-10">
        <p className="text-black-dark">{t('calibration.cancel.text1')}</p>
      </div>
      <div className="flex flex-col gap-4 md:flex-row md:justify-between">
        <Button
          classnames="underline font-bold"
          variant={ButtonVariant.Link}
          onClick={onSwitchBackToMobileCam}
        >
          {t('calibration.switchBack')}
        </Button>
        <Button onClick={() => goToStep(1)}> {t('calibration.step0.start')}</Button>
      </div>
    </>
  );
};
